import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import RenderContent from "./RenderModuleContent";

const ViewModuleModal = ({ isVisible, onClose, module }) => {
  const [show, setShow] = useState(isVisible);
  const [currentModule, setcurrentModule] = useState(null);

  useEffect(() => {
    setShow(isVisible);
  }, [isVisible]);

  useEffect(() => {
    setcurrentModule(module);
  }, [module]);

  const close = () => {
    onClose();
  };

  return (
    <Modal show={show} size="xl" centered onHide={onClose}>
      <Modal.Header className="bg-success text-white " closeButton>
        {module && (
          <div>
            <p>{module.label} </p>
          </div>
        )}
      </Modal.Header>
      <Modal.Body>
        <p>{module.description} </p>
        {currentModule ? RenderContent(currentModule.content) : null}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-sm btn-secondary" onClick={close}>
          close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewModuleModal;
